import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as automationsApi from '../api/automations';

export const fetchAutomations = createAsyncThunk('automations/fetch', async () => {
  const { data } = await automationsApi.listAutomations();
  return data;
});

export const createAutomationAsync = createAsyncThunk('automations/create', async (formData) => {
  const { data } = await automationsApi.createAutomation(formData);
  return data;
});

export const updateAutomationAsync = createAsyncThunk('automations/update', async ({ id, data: formData }) => {
  const { data } = await automationsApi.updateAutomation(id, formData);
  return data;
});

export const deleteAutomationAsync = createAsyncThunk('automations/delete', async (id) => {
  await automationsApi.deleteAutomation(id);
  return id;
});

const automationSlice = createSlice({
  name: 'automations',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAutomations.pending, (state) => { state.loading = true; })
      .addCase(fetchAutomations.fulfilled, (state, { payload }) => {
        state.loading = false; state.items = payload;
      })
      .addCase(createAutomationAsync.fulfilled, (state, { payload }) => {
        state.items.push(payload);
      })
      .addCase(updateAutomationAsync.fulfilled, (state, { payload }) => {
        const idx = state.items.findIndex((a) => a.id === payload.id);
        if (idx >= 0) state.items[idx] = payload;
      })
      .addCase(deleteAutomationAsync.fulfilled, (state, { payload }) => {
        state.items = state.items.filter((a) => a.id !== payload);
      });
  },
});

export default automationSlice.reducer;
